var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.779085 6.85742L8.22208 6.85742C8.91396 6.85742 9.25962 5.79426 8.77165 5.17465L5.04509 0.289178C4.89659 0.0970445 4.72221 0.000621083 4.50002 0.000621083C4.30166 0.000621083 4.1029 0.0971511 3.95074 0.290213L0.229804 5.17568C-0.258727 5.79319 0.0872103 6.85742 0.779085 6.85742Z",
    fill: "#BEBEBE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22206 9.14223H0.777372C0.0854965 9.14223 -0.26016 10.2058 0.227809 10.825L3.94875 15.7105C4.10079 15.9035 4.29946 16 4.49803 16C4.69645 16 4.89431 15.9035 5.04506 15.7105L8.77165 10.8243C9.25956 10.2065 8.91407 9.14223 8.22206 9.14223Z",
    fill: "#636363"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDown);
export default __webpack_public_path__ + "static/media/sort-down.3c1cb9cb87494fa883c697f838255f21.svg";
export { ForwardRef as ReactComponent };